import { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { User } from '../shared/models/User';
import { GlobalService } from '../shared/services/global';
import { HttpService } from '../shared/services/HttpService';

@Component({
  selector: 'app-tolo-u',
  standalone: true,
  imports: [],
  templateUrl: './tolo-u.component.html',
  styleUrl: './tolo-u.component.css'
})
export class ToloUComponent implements OnInit {
  public TOLO_U_URL: string;
  public CurUser: User;
  public constructor(private global: GlobalService, private http: HttpService, private router: Router) {

  }


  public ngOnInit() {
    this.global.getCurrentUser().then(x => {
      this.CurUser = x;
      this.TOLO_U_URL = environment.toloUURL;
      if (this.CurUser == null || (this.CurUser != null && !this.CurUser.IsTolomaticUser && !this.CurUser.HasPagePermission('Tolo-U'))) {
        this.router.navigate(['/']);
      }
      this.http.PostUserActivity(this.CurUser.UserId.toString(), "Tolo U", "Load", "");
      if (!this.CurUser || this.CurUser == null) {
        this.router.navigate(['/']);
      }
    });
  }
}
